// 来自web
// 生成头像字符的方法 add by 段君
// 日文取首个单词首字母 modified by wayou
// 英文取首个单词首字母  @fleven
// 下划线连接形式的认为是一个词 @fleven
// test case: http://codepen.io/anon/pen/GqYvBm?editors=0011#0
// 注意同步pdf打印那,wap,web
export function getAvatarWord(nickName?: string) {
    let avatarWord;
    let lastWordArr;
    if (nickName) {
        // cn,tw
        // 规则： 有汉字抽取最后一个汉字，
        // 没有汉字抽取最后一个英文字符段的首字母大写
        // 都没有则抽取最后一个字符大写



        lastWordArr = /([\u4e00-\u9fa5].*)/.exec(nickName) || /([a-zA-Z_]+)/.exec(nickName);




        if (lastWordArr) {
            avatarWord = lastWordArr[1].slice(0, 1).toUpperCase();
        } else {
            const _nickNameLength = nickName.length;
            avatarWord = nickName.slice(_nickNameLength - 1, _nickNameLength).toUpperCase();
        }
    }
    return avatarWord;
}

// export const COLOR_MAP = ['#ffbd2a', '#e53685', '#ff6666', '#29bebf', '#e55b36', '#0fabdf', '#bc4ca8', '#9453b6', '#05a78a'];
export const COLOR_MAP = ['#FFC610', '#E94237', '#F993A9', '#00C4D3', '#0080FF', '#009EFF', '#6739B7', '#003FDD', '#00AD4E'];

export function getAvatarBackgroundColor(id: any) {
    const avatarColorStr = COLOR_MAP[Number(id || 0) % COLOR_MAP.length];
    return avatarColorStr;
}